import { render, staticRenderFns } from "./EditorSummaryBlock.vue?vue&type=template&id=0bfbcf36&scoped=true"
import script from "./EditorSummaryBlock.vue?vue&type=script&lang=js"
export * from "./EditorSummaryBlock.vue?vue&type=script&lang=js"
import style0 from "./EditorSummaryBlock.vue?vue&type=style&index=0&id=0bfbcf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbcf36",
  null
  
)

export default component.exports